import { match } from 'path-to-regexp'
import { type UseLineInvitationCheckReturn } from '../hooks/useLineInvitationCheck'

const matchCartPage = match('{/:countryCode}/cart')
const matchCheckoutPage = match('{/:countryCode}/checkout{/*path}')

/** 判斷目標 URL 是否為購物車或結帳頁（從這些頁面登入不跳 LINE 推廣頁） */
export function isCartOrCheckoutUrl(url: string): boolean {
  try {
    const { pathname } = new URL(url, 'http://localhost')
    return !!matchCartPage(pathname) || !!matchCheckoutPage(pathname)
  }
  catch {
    return false
  }
}

/** 將目標 URL 包裝為 LINE 綁定邀請頁面的 URL */
export function wrapUrlWithLineInvitation(targetUrl: string): string {
  return `/my-account/line-binding-invitation?redirect=${encodeURIComponent(targetUrl)}`
}

/** 在目標 URL 加上 lineInvitationSubscription=true 參數 */
export function appendLineInvitationSubscriptionParam(targetUrl: string): string {
  const separator = targetUrl.includes('?') ? '&' : '?'
  return `${targetUrl}${separator}lineInvitationSubscription=true`
}

/** 根據 LINE 綁定狀態決定登入後的 redirect URL */
export function resolveLineInvitationRedirectUrl(
  redirectUrl: string,
  lineInvitationCheck: UseLineInvitationCheckReturn,
): string {
  if (isCartOrCheckoutUrl(redirectUrl)) return redirectUrl

  const { shouldShowInvitation, lineBound, lineFriend, isWithinThirtyDays } = lineInvitationCheck
  if (shouldShowInvitation) {
    return wrapUrlWithLineInvitation(redirectUrl)
  }
  if (lineBound && !lineFriend && !isWithinThirtyDays) {
    return appendLineInvitationSubscriptionParam(redirectUrl)
  }
  return redirectUrl
}
